import React, { useEffect, useState } from "react";
import { useSortableData } from "src/components/sortTable";
import { Loader } from "src/components/loader";
import { useSelector } from "react-redux";
import moment from "moment";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import { convertIsoToLocalDateTime, getFloatValue, tConvert } from "src/constant";
import { Tooltip } from "@mui/material";

export const DispatchOrderTable = ({ allDispatchTableData }) => {
  /** redux store useDispatch & useSelector ------------------------------ **/
  const navigate = useNavigate();
  const { dispatchOrderLoadingState } = useSelector((state) => state.dispatch);

  /** hooks useState ----------------------------------------------------- **/

  const [dispatchOrderShowData, setDispatchOrderShowData] = useState([]);
  const [selectedRowId, setSelectedRowId] = useState();
  const [showViewRecordButton, setShowViewRecordButton] = useState(false);

  /** variable declaration ----------------------------------------------------- **/
  let userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const clientCount = _.unionBy(
    _.map(dispatchOrderShowData || [], (d) => d?.clientName),
    (d) => d
  ).length;
  const projectCount = _.unionBy(
    _.map(dispatchOrderShowData || [], (d) => d?.projectName),
    (d) => d
  ).length;
  const depotCount = _.unionBy(
    _.map(dispatchOrderShowData || [], (d) => d.depotCode),
    (d) => d
  ).length;
  const { items, requestSort, sortConfig } = useSortableData(
    dispatchOrderShowData
  );

  /** hooks useEffect----------------------------------------------------- **/

  useEffect(() => {
    let setDispatchOrderData = dataManipulationPipe(
      allDispatchTableData
    );
    if (userDetails?.roles == "DepotManager") {
      const filteredObject = _.filter(
        setDispatchOrderData || [],
        (d) => d.status !== "Review"
      );
      setDispatchOrderShowData([...filteredObject]);
    } else {
      if (Array.isArray(setDispatchOrderData)) {
        setDispatchOrderShowData([...setDispatchOrderData]);
      } else {
        console.error("setGoodsinData is not iterable:", setDispatchOrderData);
      }
    }
  }, [allDispatchTableData]);

  /** handler functions--------------------------------------------------- **/
  const calulateInternalStorage = (data, type) => {
    let totalInternalSpace = 0;
    data &&
      data.map((i) => {
        i.dispatchItems &&
          i.dispatchItems[0] &&
          i.dispatchItems.map((d) => {
            if (d.storageId == type) {
              totalInternalSpace = totalInternalSpace + d.spaceReleased;
            }
          });
      });
    return totalInternalSpace || 0;
  };

  const dataManipulationPipe = (data) => {
    let result =
      data &&
      data[0] &&
      data.map((o, i) => {
        let temp = { ...o };
        const localDateTime = convertIsoToLocalDateTime(`${temp?.dueDate}.00Z`, "DD-MMM-YYYY HH:mm")
        return {
          ...o,
          date: localDateTime,
          orderNo: temp?.orderNo,
          clientName: temp?.clientName,
          projectName: temp?.projectName,
          projectManager: temp?.projectManager,
          depotCode: temp?.depotCode,
          raisedOn: temp?.raisedOn
            ? convertIsoToLocalDateTime(`${temp?.raisedOn}.00Z`, "DD-MMM-YYYY HH:mm")
            : "",
          status: temp?.statusValue,
          itemsCount: `${temp?.dispatchItemCount|| 0} Of ${temp?.itemCount  || 0
          }`,
          interiorSpaceCount: temp.interiorSpace,
          externalSpaceCount: temp.exteriorSpace,
          vehiclesCount: temp?.vehicles || 0,
          depotManager:
            temp?.statusValue == "Pending" || temp?.statusValue == "Review"
              ? "--"
              : `${temp?.depotManager || ""}  `,
        };
      });
    return result || [];
  };

  const getClassNamesFor = (name) => {
    if (!sortConfig) {
      return;
    }
    return sortConfig.key === name ? sortConfig.direction : undefined;
  };

  const handleRowClick = (id) => {
    setSelectedRowId(id);
    setShowViewRecordButton(!showViewRecordButton);
  };

  const handleViewRecordClick = (id, event) => {
    if (event.ctrlKey || event.metaKey) {
      window.open(`#/app/dispatchorders/detail/${id}`, '_blank');
    } else {
      navigate(`/app/dispatchorders/detail/${id}`)
    }
  }

  if (dispatchOrderLoadingState) {
    return <Loader />;
  }
  return (
    <>
      <div>
        <div
          className={`table-responsive d-flex mt-2 ${items.length < 10
            ? ""
            : "dispatchorder-table-main-div-when-items-more"
            }`}
        >
          <table
            className="table goodsin-table table-borderless"
            style={{ width: "100%" }}
          >
            <thead className="goodsin-table-header">
              <tr>
                <th
                  scope="col"
                  style={{ minWidth: 150 }}
                  className={`
                  ${getClassNamesFor("date")}
                   text-uppercase text-primary`}
                  onClick={() => requestSort("date")}
                >
                  DUE / PICK UP
                </th>
                <th
                  scope="col"
                  className={`${getClassNamesFor(
                    "orderNo"
                  )} text-uppercase text-primary set-header-width-for-long-text`}
                  onClick={() => requestSort("orderNo")}
                >
                  order number
                </th>
                <th
                  scope="col"
                  style={{ minWidth: 200 }}
                  className={`${getClassNamesFor(
                    "clientName"
                  )} text-uppercase text-primary`}
                  onClick={() => requestSort("clientName")}
                >
                  client
                </th>
                <th
                  scope="col"
                  style={{ minWidth: 150 }}
                  className={`${getClassNamesFor(
                    "projectName"
                  )} text-uppercase text-primary`}
                  onClick={() => requestSort("projectName")}
                >
                  project
                </th>
                <th
                  scope="col"
                  style={{ minWidth: 150 }}
                  className={`${getClassNamesFor(
                    "projectManager"
                  )} text-uppercase text-primary`}
                  onClick={() => requestSort("projectManager")}
                >
                  project Manager
                </th>
                {(userDetails?.roles == "SuperAdmin" ||
                  userDetails?.roles == "Admin") && (
                    <th
                      scope="col"
                      className={`${getClassNamesFor(
                        "depotCode"
                      )} text-uppercase text-primary set-header-width-for-m-text`}
                      onClick={() => requestSort("depotCode")}
                    >
                      depot
                    </th>
                  )}
                <th
                  scope="col"
                  style={{ minWidth: 150 }}
                  className={`${getClassNamesFor(
                    "raisedOn"
                  )} text-uppercase text-primary`}
                  onClick={() => requestSort("raisedOn")}
                >
                  raised
                </th>
                <th
                  scope="col"
                  className={`${getClassNamesFor(
                    "status"
                  )} text-uppercase text-primary set-header-width-for-long-text`}
                  onClick={() => requestSort("status")}
                >
                  status
                </th>
                <th
                  scope="col"
                  className={`${getClassNamesFor(
                    "itemsCount"
                  )} text-primary set-header-width-for-m-text text-uppercase`}
                  onClick={() => requestSort("itemsCount")}
                >
                  items
                </th>
                <th
                  scope="col"
                  className={`${getClassNamesFor(
                    "interiorSpaceCount"
                  )} text-primary set-header-width-for-m-text`}
                  onClick={() => requestSort("interiorSpaceCount")}
                >
                  INT.m<sup>2</sup>
                </th>
                <th
                  scope="col"
                  className={`${getClassNamesFor(
                    "externalSpaceCount"
                  )} text-uppercase text-primary set-header-width-for-m-text`}
                  onClick={() => requestSort("externalSpaceCount")}
                >
                  EXT.m<sup>2</sup>
                </th>
                <th
                  scope="col"
                  style={{ minWidth: 80 }}
                  className={`${getClassNamesFor(
                    "vehiclesCount"
                  )} text-uppercase text-primary`}
                  onClick={() => requestSort("vehiclesCount")}
                >
                  vehicles
                </th>
                <th
                  scope="col"
                  style={{ minWidth: 150 }}
                  className={`${getClassNamesFor(
                    "depotManager"
                  )} text-uppercase text-primary`}
                  onClick={() => requestSort("depotManager")}
                >
                  depot manager
                </th>
              </tr>
            </thead>
            <tbody className="goods-table-body">
              {items.length > 0 ? (
                items.map((item, index) => {
                  return (
                    <React.Fragment key={index}>
                      <tr
                        onClick={() => handleRowClick(item.id)}
                        className={`goodsin-tr 
                         ${selectedRowId == item.id ? "row-border" : ""}`}
                      >
                        <td
                         className={`text-uppercase ${item.status == "Loading"
                         ? "add-dispatch-tbl-loading-status-color"
                         : item.status == "Cancelled" ? 
                            "red-clientname-color"
                         : "add-dispatch-tbl-black-status-color"
                         }`}
                        >{item?.date}</td>
                        <td
                         className={`text-uppercase ${item.status == "Loading"
                         ? "add-dispatch-tbl-loading-status-color"
                         : item.status == "Cancelled" ? 
                            "red-clientname-color"
                         : "add-dispatch-tbl-black-status-color"
                         }`}
                        >{item?.orderNo}</td>
                        <td
                         className={`text-uppercase ${item.status == "Loading"
                         ? "add-dispatch-tbl-loading-status-color"
                         : item.status == "Cancelled" ? 
                            "red-clientname-color"
                         : "add-dispatch-tbl-black-status-color"
                         }`}
                        >{item?.clientName || ""}</td>
                        <td
                          className={`text-uppercase ${item.status == "Loading"
                          ? "add-dispatch-tbl-loading-status-color"
                          : item.status == "Cancelled" ? 
                             "red-clientname-color"
                          : "add-dispatch-tbl-black-status-color"
                          }`}
                        >
                          <Tooltip
                            title={
                              <span className="project-dropdown-tooltip-style2 project-dropdown-tooltip-style">{`${item?.projectName}`}</span>
                            }
                            arrow
                          >
                            <div className="text-truncate">
                              {item?.projectName || ""}
                            </div>
                          </Tooltip>
                        </td>

                        <td
                         className={`text-uppercase ${item.status == "Loading"
                         ? "add-dispatch-tbl-loading-status-color"
                         : item.status == "Cancelled" ? 
                            "red-clientname-color"
                         : "add-dispatch-tbl-black-status-color"
                         }`}
                        >{item?.projectManager || ""}</td>
                        {(userDetails?.roles == "SuperAdmin" ||
                          userDetails?.roles == "Admin") && (
                            <td
                            className={`text-uppercase ${item.status == "Loading"
                            ? "add-dispatch-tbl-loading-status-color"
                            : item.status == "Cancelled" ? 
                               "red-clientname-color"
                            : "add-dispatch-tbl-black-status-color"
                            }`}
                            >{item?.depotCode || ""}</td>
                          )}
                        <td
                          className={`text-uppercase ${item.status == "Loading"
                            ? "add-dispatch-tbl-loading-status-color"
                            : item.status == "Cancelled" ? 
                               "red-clientname-color"
                            : "add-dispatch-tbl-black-status-color"
                            }`}
                        >{item?.raisedOn || ""}</td>
                        <td
                          className={`text-uppercase ${item.status == "Review" || item.status == "Pending" || item.status =="Cancelled"
                            ? "add-dispatch-tbl-red-status-color"
                            : item.status == "Loading"
                              ? "add-dispatch-tbl-loading-status-color"
                              : item.status == "Delivered" ||
                                item.status == "Dispatched"
                                ? "add-dispatch-tbl-green-status-color"
                                : item.status == "InTransit"
                                  ? "add-dispatch-tbl-blue-status-color"
                                  : "add-dispatch-tbl-black-status-color"
                            }`}
                        >
                          {item.status}
                        </td>
                        <td
                         className={`text-uppercase ${item.status == "Loading"
                         ? "add-dispatch-tbl-loading-status-color"
                         : item.status == "Cancelled" ? 
                            "red-clientname-color"
                         : "add-dispatch-tbl-black-status-color"
                         }`}
                        >{item?.itemsCount}</td>
                        <td
                         className={`text-uppercase ${item.status == "Loading"
                         ? "add-dispatch-tbl-loading-status-color"
                         : item.status == "Cancelled" ? 
                            "red-clientname-color"
                         : "add-dispatch-tbl-black-status-color"
                         }`}
                        >{getFloatValue(item?.interiorSpaceCount) || 0}</td>
                        <td
                          className={`text-uppercase ${item.status == "Loading"
                          ? "add-dispatch-tbl-loading-status-color"
                          : item.status == "Cancelled" ? 
                             "red-clientname-color"
                          : "add-dispatch-tbl-black-status-color"
                          }`}
                        >{getFloatValue(item?.externalSpaceCount) || 0}</td>

                        <td
                         className={`text-uppercase ${item.status == "Loading"
                         ? "add-dispatch-tbl-loading-status-color"
                         : item.status == "Cancelled" ? 
                            "red-clientname-color"
                         : "add-dispatch-tbl-black-status-color"
                         }`}
                        >{item?.vehiclesCount || 0}</td>
                        {item.status === "Pending" ||
                          item.status === "Review" ? (
                          <td>--</td>
                        ) : (
                          <td
                          className={`text-uppercase ${item.status == "Loading"
                          ? "add-dispatch-tbl-loading-status-color"
                          : item.status == "Cancelled" ? 
                             "red-clientname-color"
                          : "add-dispatch-tbl-black-status-color"
                          }`}
                          >{item?.depotManager || ""}</td>
                        )}
                      </tr>
                      {showViewRecordButton && selectedRowId == item.id && (
                        <tr className={`view-record-button`}>
                          <td>
                            <button onClick={(e) => handleViewRecordClick(item.id, e)}
                              type="button"
                              className="text-uppercase view-button"
                            >
                              <i className="bi bi-eye-fill view-record-icon"></i>{" "}
                              View Record
                            </button>
                          </td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })
              ) : (
                <tr>
                  <td
                    className="not-found-txt"
                    colSpan="7"
                    style={{ textAlign: "center" }}
                  >
                    No Records Found
                  </td>
                </tr>
              )}
            </tbody>
            <tfoot className="goodsin-table-footer-style">
              <tr>
                <td></td>

                <td>
                  <span className="footer-count-color">
                    {dispatchOrderShowData.length}{" "}
                  </span>
                  <span className="footer-label-color">Records</span>
                </td>

                <td>
                  <span className="footer-count-color">{clientCount} </span>
                  <span className="footer-label-color">Clients</span>
                </td>

                <td>
                  <span className="footer-count-color">{projectCount} </span>
                  <span className="footer-label-color">Projects</span>
                </td>

                <td></td>
                {(userDetails?.roles == "SuperAdmin" ||
                  userDetails?.roles == "Admin") && (
                    <td>
                      <span className="footer-count-color">{depotCount} </span>
                      <span className="footer-label-color">Depots</span>
                    </td>
                  )}

                <td></td>
                <td></td>
                <td>
                  <span className="footer-count-color">
                    {_.sumBy(
                      dispatchOrderShowData || [],
                      (d) => d.dispatchItemCount
                    )}{" "}
                  </span>
                  <span className="footer-label-color">Units Delivered</span>
                </td>

                <td>
                  <span className="footer-count-color">
                    {getFloatValue(
                      _.sumBy(
                        dispatchOrderShowData || [],
                        (d) => d.interiorSpaceCount
                      )
                    )}
                  </span>
                  <span className="footer-label-color">
                    {" "}
                    Int. (m<sup>2</sup>)
                  </span>
                </td>

                <td>
                  <span className="footer-count-color">
                    {getFloatValue(
                      _.sumBy(
                        dispatchOrderShowData || [],
                        (d) => d.externalSpaceCount
                      )
                    )}
                  </span>
                  <span className="footer-label-color">
                    {" "}
                    Ext. (m<sup>2</sup>)
                  </span>
                </td>

                <td></td>
                <td></td>
              </tr>
            </tfoot>
            {/* <Waypoint onEnter={loadMoreRecords}>
            </Waypoint> */}
          </table>
        </div>
      </div>
    </>
  );
};
